var escape = require("../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".layouts-create[data-v-7f110e8a]{background-color:#e9c385;background-image:url(" + escape(require("assets/layouts-create-bg.jpg")) + ")}", ""]);

// exports
